import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const WelcomeRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.WELCOME.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/welcome/welcome.module').then(m => m.WelcomePageModule),
    canActivate: [NavigationGuard],
  },
];
